import { EMOJI_SHORTCODE_MAP } from '@recruitee/emoji';

const Emoticon = {
  Heart: EMOJI_SHORTCODE_MAP['heart'],
  BrokenHeart: EMOJI_SHORTCODE_MAP['broken_heart'],
  Sunglasses: EMOJI_SHORTCODE_MAP['sunglasses'],
  Anguished: EMOJI_SHORTCODE_MAP['anguished'],
  NeutralFace: EMOJI_SHORTCODE_MAP['neutral_face'],
  MonkeyFace: EMOJI_SHORTCODE_MAP['monkey_face'],
  Smiley: EMOJI_SHORTCODE_MAP['smiley'],
  Smile: EMOJI_SHORTCODE_MAP['smile'],
  Wink: EMOJI_SHORTCODE_MAP['wink'],
  Laughing: EMOJI_SHORTCODE_MAP['laughing'],
  OpenMouth: EMOJI_SHORTCODE_MAP['open_mouth'],
  Angry: EMOJI_SHORTCODE_MAP['angry'],
  SlightlySmilingFace: EMOJI_SHORTCODE_MAP['slightly_smiling_face'],
  Disappointed: EMOJI_SHORTCODE_MAP['disappointed'],
  Confused: EMOJI_SHORTCODE_MAP['confused'],
  StuckOutTongue: EMOJI_SHORTCODE_MAP['stuck_out_tongue'],
  StuckOutTongueWinkingEye: EMOJI_SHORTCODE_MAP['stuck_out_tongue_winking_eye'],
  KissingHeart: EMOJI_SHORTCODE_MAP['kissing_heart'],
};

export const OldEmoticonEmojiMap = {
  ['<3']: Emoticon.Heart,
  ['</3']: Emoticon.BrokenHeart,
  ['8)']: Emoticon.Sunglasses,
  ['D:']: Emoticon.Anguished,
  [':|']: Emoticon.NeutralFace,
  [':o)']: Emoticon.MonkeyFace,
  ['=)']: Emoticon.Smiley,
  ['=-)']: Emoticon.Smiley,
  [':D']: Emoticon.Smile,
  [':-D']: Emoticon.Smile,
  [';)']: Emoticon.Wink,
  [';-)']: Emoticon.Smile,
  [':>']: Emoticon.Laughing,
  [':->']: Emoticon.Laughing,
  [':o']: Emoticon.OpenMouth,
  [':-O']: Emoticon.OpenMouth,
  ['>:(']: Emoticon.Angry,
  ['>:-(']: Emoticon.Angry,
  [':)']: Emoticon.SlightlySmilingFace,
  ['(:']: Emoticon.SlightlySmilingFace,
  [':-)']: Emoticon.SlightlySmilingFace,
  [':(']: Emoticon.Disappointed,
  ['):']: Emoticon.Disappointed,
  [':-(']: Emoticon.Disappointed,
  [':/']: Emoticon.Confused,
  [':-/']: Emoticon.Confused,
  [':\\']: Emoticon.Confused,
  [':-\\']: Emoticon.Confused,
  [':P']: Emoticon.StuckOutTongue,
  [':-p']: Emoticon.StuckOutTongue,
  [':-b']: Emoticon.StuckOutTongue,
  [';p']: Emoticon.StuckOutTongueWinkingEye,
  [';-p']: Emoticon.StuckOutTongueWinkingEye,
  [';b']: Emoticon.StuckOutTongueWinkingEye,
  [';-b']: Emoticon.StuckOutTongueWinkingEye,
  [':*']: Emoticon.KissingHeart,
  [':-*']: Emoticon.KissingHeart,
};
